module.exports = __webpack_public_path__ + "img/@logo_kyobo.08022e31.png";